import axios from 'axios';
import { TokenLogout } from "API/Logout/logout"

const url = process.env.REACT_APP_BANKVERIFY_URL;

export const PaymentReport = async (page, limit, agentName,serviceType,bankName,SearchState,district, setIsLoading, setTotalCount, setSuccess,setError) => {
  setIsLoading(true);
  // const payload = {
  //   ...(agentName && { agent_name: agentName }),
  //   ...(serviceType && { service_type: serviceType }),
  //   ...(bankName && { bank_name: bankName }),
  //   ...(SearchState && { state: SearchState }),
  //   ...(district && { district: district }),
  // };
  try {
    await axios
      .post(
        `${url}ccavenue/agent/payment/report/all?page=${page}&limit=${limit}`,
        {...(agentName && { agent_name: agentName }),
        ...(serviceType && { service_type: serviceType }),
        ...(bankName && { bank_name: bankName }),
        ...(SearchState && { state: SearchState }),
        ...(district && { district: district }),},
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setSuccess(res.data.all_agent_payment_data);
        setTotalCount(res.data.total_count);
        setIsLoading(false);
      })
      .catch((error) => {
        TokenLogout(error)
        setError(error.response?error.response.data.error:'Unable to retreive payment details')
        console.log('error', error);
        setIsLoading(false);
      });
  } catch (error) {
    TokenLogout(error)
    setError(error.response?error.response.data.error:'Unable to retreive payment details')
    console.log('error', error);
    setIsLoading(false);
  }
};

export const FiBankList = async (setBankList) => {
  try {
    await axios
      .get(`${url}finvesta-user/fi_banks_list`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setBankList(res.data);
        }
      })
      .catch((error) => {
        TokenLogout(error)
        console.log(error);
      });
  } catch (error) {
    TokenLogout(error)
    console.log(error);
  }
};
